/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ShapeCircleMOffIcon24Regular = forwardRef('ShapeCircleMOffIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.03 2.97a.75.75 0 0 0-1.06 1.06l2.868 2.868a8 8 0 0 0 11.264 11.264l2.868 2.868a.75.75 0 1 0 1.06-1.06l-17-17Zm12.005 14.126L6.904 7.965a6.5 6.5 0 0 0 9.131 9.131Z" }),
        React.createElement("path", { d: "M18.5 12c0 .91-.187 1.775-.524 2.562l1.126 1.125A8 8 0 0 0 8.313 4.898l1.125 1.126A6.5 6.5 0 0 1 18.5 12Z" })));
});
